class InsuranceController {
  constructor() {
    this.name = 'insurance';
  }
}

export default InsuranceController;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance.controller.js